import { p as palette } from '../base/color-DMp1DFwP.js';
import { t as typography } from '../base/typography-Bqsizo4g.js';
import { s as spacing, m as mobileSpacing } from '../base/spacing-zNVNrnl_.js';

/* eslint-disable id-length */
const dividerStyles = {
  bg: palette.white,
  color: palette.gray[100],
  margin: `${spacing.base} 0`,
  textPadding: `0 ${spacing.mini}`,
  textColor: typography.color.tertiary
};
const mobileDividerStyles = {
  mobile: {
    margin: `${mobileSpacing.base} 0`,
    textPadding: `0 ${mobileSpacing.mini}`
  }
};

export { dividerStyles as d, mobileDividerStyles as m };
//# sourceMappingURL=divider-BcpVpxf1.js.map
